import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemType } from "sprout-graphql";
import { useParams } from "react-router-dom";
import TopicPageTabs from "../TopicPage_Tabs";
import TopicPageHeader from "../TopicPageHeader";
import TopicPageLoader from "../TopicPage_Loader";
import TopicPageViewsTabsPosts from "./TopicPageViewsTabsPosts";
import TopicPageViewsTabsSections from "./TopicPageViewsTabsSections";
import TopicPageViewsTabsEmptyList from "./TopicPageViewsTabsEmptyList";
const TopicPageViewsTabsMainProps = (props)=>{
    var ref, ref1;
    const { topic , hasNextPage , loading , loadMore , type , updateList  } = props;
    const { view  } = useParams();
    let items;
    if (type === ItemType.Post) items = (ref = topic.posts) === null || ref === void 0 ? void 0 : ref.nodes;
    else if (type === ItemType.Topic) items = (ref1 = topic.sections) === null || ref1 === void 0 ? void 0 : ref1.nodes;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageHeader, {
                topic: topic
            }),
            /*#__PURE__*/ _jsx(TopicPageTabs, {}),
            loading && !items && /*#__PURE__*/ _jsx(TopicPageLoader, {}),
            items && items.length === 0 && /*#__PURE__*/ _jsx(TopicPageViewsTabsEmptyList, {
                variant: view,
                type: type
            }),
            items && items.length !== 0 && type === ItemType.Post && /*#__PURE__*/ _jsx(TopicPageViewsTabsPosts, {
                hasNextPage: hasNextPage,
                loading: loading,
                loadMore: loadMore,
                posts: items,
                updateList: updateList
            }),
            items && items.length !== 0 && type === ItemType.Topic && /*#__PURE__*/ _jsx(TopicPageViewsTabsSections, {
                hasNextPage: hasNextPage,
                loading: loading,
                loadMore: loadMore,
                sections: items,
                updateList: updateList
            })
        ]
    });
};
export default TopicPageViewsTabsMainProps;
